import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterFamily", "getFamilyValueResolver", "operator"];
import { getInboundDbImportReferenceResolver } from 'customer-data-filters-ui/utils/getInboundDbImportReferenceResolver';
import DisplayValueEnumeration from './DisplayValueEnumeration';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueInboundDbImport = _ref => {
  let {
      filterFamily,
      getFamilyValueResolver,
      operator
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const resolver = getInboundDbImportReferenceResolver(getFamilyValueResolver(operator), filterFamily);
  return /*#__PURE__*/_jsx(DisplayValueEnumeration, Object.assign({
    getFamilyValueResolver: () => resolver,
    operator: operator
  }, rest));
};
export default DisplayValueInboundDbImport;